// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"12e52d2f","291":"8ca80bdd","307":"d07434c0","453":"f0436a81","733":"ac119c37"}[chunkId] + ".chunk.js";
};